import React from 'react';
import BasicLayout from 'layout/Basic';
import getConfig from 'next/config';
import { convertProps } from 'lib/parseAPIResponse';
import SubCategoryPage, { Props } from 'containers/SubCategory';
import { NextSeo } from 'next-seo';

export const SubCategory = (props: Props) => {
    const { url } = getConfig().publicRuntimeConfig;
    return (
        <BasicLayout ads={props.ads}>
            <NextSeo
                title={`${props.category.title}`}
                canonical={`${url}/${props.category.parent.seoSlug}/${props.category.seoSlug}`}
            />
            <SubCategoryPage {...props} />
        </BasicLayout>
    );
};

export async function getServerSideProps({ params, query }) {
    if (params.all.length !== 2) {
        return {
            notFound: true
        };
    }
    const categorySlug = params.all[0];
    const indexSlug = params.all[1].includes(',')
        ? params.all[1].substr(0, params.all[1].indexOf(','))
        : params.all[1];
    const page = query.page || 1;
    const { apiUrl } = getConfig().publicRuntimeConfig;

    return Promise.all([
        fetch(`${apiUrl}/public/api/categories/${categorySlug}/${indexSlug},${page}`),
        fetch(`${apiUrl}/public/api/naszadsik?path=${categorySlug}/${indexSlug}`)
    ]).then(async ([res1, res2]) => {
        const data = await res1.json();
        if (data.code === 404) {
            return {
                notFound: true
            };
        }
        const ads = await res2.json();

        return { props: { ...convertProps(ads), ...convertProps(data) } };
    });
}

export default SubCategory;
